import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import PropTypes from "prop-types";

export default function SimpleBackdrop({ openLoader }) {
  return (
    <Backdrop
      sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
      open={openLoader} // Fixed variable name
    >
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

SimpleBackdrop.propTypes = {
  openLoader: PropTypes.bool.isRequired, // Better to explicitly define type
};
